<template>
    <v-dialog v-model="dialog" width="700" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title
                style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field v-model="code" :rules="[formRules.required]"
                                label="Outcome Code (e.g. IT01)" variant="outlined" rounded="lg" type="text"
                                color="darkGreen">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea expand v-model="description" :rules="[formRules.required]"
                                label="Description" variant="outlined" rounded="lg" rows="3" color="darkGreen">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1"
                    @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen"
                    @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    emits: ["refresh"],
    data() {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            code: null,
            description: null,
        }
    },
    methods: {
        initAdd() {
            this.dialog = true
            this.dialog_title = 'Program Outcomes'
            this.dialog_sub_title = 'Add new outcome information'
            this.action = 'add'

            this.code = null
            this.description = null
        },
        initEdit(data) {
            this.dialog = true
            this.dialog_title = 'Program Outcomes'
            this.dialog_sub_title = 'Update outcome information'
            this.action = 'edit'

            this.id = data.id
            this.code = data.code
            this.description = data.description
        },
        async validateForm() {
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                this.loading = true
                let formData = {
                    programId: this.$store.state.user.program.id,
                    code: this.code,
                    description: this.description,
                    semester_schoolyear: this.$store.state.semester_schoolyear.id
                }

                if (this.action == 'add') {
                    let res = await this.axiosCall('/program-outcomes', 'post', formData, true)
                    if(res.data){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Outcome successfully added!')
                        this.closeDialog()
                    }
                }
                else if (this.action == 'edit') {
                    let res = await this.axiosCall('/program-outcomes/' + this.id, 'patch', formData, true)
                    if(res.data){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Outcome successfully updated!')
                        this.closeDialog()
                    }
                }
            }
        },
        closeDialog() {
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>